// extracted by mini-css-extract-plugin
export default {"tabs":"tabs___wLyz1","tabs_item":"tabs_item___NwI_D","active":"active___ZwH0s"};